module.exports = __webpack_public_path__ + "img/01 02_question.191df8be.png";